import ScrollToTop from "react-scroll-to-top";
import './main_root.css'

function Scroll_To_top() {
    
    return (
        <ScrollToTop smooth top="300" className="Scroll_To_top" color="#ffffff"/>
    )
}
export default Scroll_To_top;